import React, { useState } from 'react';
import ContactModal from './ContactModal';
import SettingsModal from './SettingsModal';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="bg-deep-green p-4 shadow-md border-pattern">
      <div className="container mx-auto flex items-center justify-between">
        {/* Hamburger menu */}
        <div className="relative">
          <button 
            onClick={toggleMenu}
            className="flex items-center justify-center p-2 rounded-md hover:bg-medium-green focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            style={{ color: 'var(--color-header-text)' }}
            aria-expanded="false"
          >
            <span className="sr-only">Open main menu</span>
            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          
          {/* Dropdown menu */}
          {menuOpen && (
            <div 
              className="origin-top-left absolute left-0 mt-2 w-48 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50"
              style={{ backgroundColor: 'var(--color-card-bg)' }}
            >
              <div className="py-1" role="menu" aria-orientation="vertical">
                <button 
                  onClick={() => {
                    setShowContactModal(true);
                    setMenuOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-sm text-charcoal bg-transparent hover:bg-light-gray focus-visible:bg-light-gray"
                  role="menuitem"
                >
                  Contact Us
                </button>
                <button 
                  onClick={() => {
                    setShowSettingsModal(true);
                    setMenuOpen(false);
                  }}
                  className="block w-full text-left px-4 py-2 text-sm text-charcoal bg-transparent hover:bg-light-gray focus-visible:bg-light-gray"
                  role="menuitem"
                >
                  Settings
                </button>
              </div>
            </div>
          )}
        </div>
        
        {/* Title */}
        <div className="flex items-center">
          <span className="text-gold mr-3 text-2xl">☪</span>
          <h1 className="text-2xl font-bold font-kufi" style={{ color: 'var(--color-header-text)' }}>Quran Reader</h1>
        </div>
        
        {/* Settings Button */}
        <button
          onClick={() => setShowSettingsModal(true)}
          className="p-2 rounded-md hover:bg-medium-green focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
          style={{ color: 'var(--color-header-text)' }}
          aria-label="Open settings"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </button>
      </div>
      
      {/* Modals */}
      {showContactModal && <ContactModal onClose={() => setShowContactModal(false)} />}
      {showSettingsModal && <SettingsModal onClose={() => setShowSettingsModal(false)} />}
    </header>
  );
};

export default Header;